// Add active class to form-check when label is clicked. Match Firefox's input label behavior on chrome.

import { ReportValidity } from 'smg/form';

function targetElements($target: HTMLElement) {
    if (!($target instanceof HTMLElement && $target.matches('.form-check *,.form-check-input'))) {
        return;
    }

    const $formCheck = $target.closest<HTMLElement>('.form-check');
    let $formCheckInput: HTMLElement | null = null;
    let $formCheckLabel: HTMLElement | null = null;
    if ($formCheck) {
        $formCheckInput = $formCheck.querySelector<HTMLElement>('.form-check-input');
        $formCheckLabel = $formCheck.querySelector<HTMLElement>('.form-check-label');
    } else if ($target.matches('.form-check-input')) {
        const $maybeFormCheck = $target.closest<HTMLElement>('.form-check');
        if ($maybeFormCheck) {
            $formCheckInput = $maybeFormCheck.querySelector<HTMLElement>('.form-check-input');
            $formCheckLabel = $maybeFormCheck.querySelector<HTMLElement>('.form-check-label');
            $target = $maybeFormCheck;
        }
    }

    return { $formCheckInput, $formCheckLabel };
}

document.addEventListener('mouseover', e => {
    const { $formCheckInput, $formCheckLabel } = targetElements(e.target as HTMLElement) || {};
    if (!$formCheckInput || !$formCheckLabel || $formCheckInput.matches(':disabled') || $formCheckInput.matches(':focus') || $formCheckInput.matches(':read-only')) {
        return;
    }

    $formCheckInput.classList.add('active');

    const deactivate = () => {
        $formCheckInput.classList.remove('active');
    };
    const deactivateAndRemoveListeners = () => {
        deactivate();
        $formCheckLabel.removeEventListener('mouseover', deactivateAndRemoveListeners);
        $formCheckLabel.removeEventListener('focus', deactivateAndRemoveListeners);
    };

    $formCheckLabel.addEventListener('mouseout', deactivateAndRemoveListeners);
    $formCheckLabel.addEventListener('focus', deactivateAndRemoveListeners);
});

document.addEventListener('focus', e => {
    const { $formCheckInput, $formCheckLabel } = targetElements(e.target as HTMLElement) || {};
    if (!$formCheckInput || !$formCheckLabel || $formCheckInput.matches(':disabled') || $formCheckInput.matches(':focus') || $formCheckInput.matches(':read-only')) {
        return;
    }

    $formCheckInput.classList.add('active');

    const deactivate = () => {
        $formCheckInput.classList.remove('active');
    };
    const deactivateAndRemoveListeners = () => {
        deactivate();
        $formCheckLabel.removeEventListener('blur', deactivateAndRemoveListeners);
    };

    $formCheckLabel.addEventListener('blur', deactivateAndRemoveListeners);
});

document.querySelectorAll('.form-check').forEach($el => $el.classList.add('validity-parent'));

if (document.body.id === 'checks-radios') {
    const $formCheckRadios = document.querySelector<HTMLFormElement>('#checks-radios-form');
    document.querySelector('#invalidate')?.addEventListener('click', () => {
        document.querySelectorAll<HTMLInputElement>('input.form-check-input').forEach($input => {
            $input.setCustomValidity('Invalid input');
        });
        if ($formCheckRadios) {
            ReportValidity($formCheckRadios);
        }
    });
}
